import initializeHeader from "./components/header/index";
import initCitySelectionListeners from "./components/selectCity";
import initializeBrowserGeolocation from "./components/geolocation";

$(() => {
    initializeHeader();
    initCitySelectionListeners();
    initializeBrowserGeolocation();
});
